import { IReportTypeCardProps } from "../../model/Report";
import ReportStyles from "../../styles/pages/Summaries/ReportStyles";

const { StyledCardDiv, StyledCardTitle, StyledCardText } = ReportStyles;

const TypeReportCard: React.FC<IReportTypeCardProps> = ({
    icon,
    imgDescription,
    description,
    title,
}) => {
    return (
        <StyledCardDiv>
            <div>{!!icon && <img src={icon} alt={imgDescription} />}</div>
            <StyledCardTitle>{title}</StyledCardTitle>
            <StyledCardText>{description}</StyledCardText>
        </StyledCardDiv>
    );
};

export default TypeReportCard;
